import React from 'react';

const Attention = () => (
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.18075 0.482626L0.136139 7.49495C0.0470567 7.6494 0 7.82613 0 8.00624C0 8.55508 0.427708 9 0.955313 9H9.04454C9.21769 9 9.38758 8.95105 9.53605 8.85838C9.98846 8.57601 10.1352 7.96558 9.86372 7.49495L5.8191 0.482626C5.73843 0.342754 5.62589 0.225691 5.49143 0.141768C5.03902 -0.140607 4.4522 0.0119998 4.18075 0.482626ZM5.6 2.66122V5.83948H4.4V2.66122H5.6ZM5.6 6.50821V7.81424H4.4V6.50821H5.6Z"
      fill="white"
    />
  </svg>
);

export default Attention;
